import { ButtonV2 } from "../FormControlsV2";
import { useOnboarding } from "../../hooks/useOnboarding";
import "./OnboardingFooterV2.css";

type OnboardingFooterV2Props = {
  nextStepEvent?: () => boolean | Promise<boolean>;
  backStepEvent?: () => boolean | Promise<boolean>;
  nextLabel?: string;
  disabled?: boolean;
};

export function OnboardingFooterV2({
  nextStepEvent,
  backStepEvent,
  nextLabel,
  disabled,
}: OnboardingFooterV2Props) {
  const { advanceStep, backStep, userProgress, screenNumber, subScreenNumber } = useOnboarding();
  const isFirstStep = screenNumber === 1 && subScreenNumber === 0;
  const maxSection =
    userProgress.length > 0 ? Math.max(...userProgress.map((p) => p.section)) : 0;
  const lastSectionProgress = userProgress.find((p) => p.section === maxSection);
  const lastSubCount = lastSectionProgress?.screens?.length ?? 0;
  const isLastStep =
    maxSection > 0 &&
    screenNumber === maxSection &&
    lastSubCount > 0 &&
    subScreenNumber === lastSubCount - 1;

  async function handleBack() {
    if (backStepEvent && !(await backStepEvent())) return;
    backStep(userProgress, screenNumber, subScreenNumber);
  }

  async function handleNext() {
    if (nextStepEvent && !(await nextStepEvent())) return;
    advanceStep(userProgress, screenNumber, subScreenNumber);
  }

  return (
    <footer className="ov2-footer">
      {!isFirstStep && (
        <ButtonV2 variant="secondary" onClick={handleBack}>
          Voltar
        </ButtonV2>
      )}
      <ButtonV2 disabled={disabled} onClick={handleNext}>
        {nextLabel || (isLastStep ? "Concluir" : "Avançar")}
      </ButtonV2>
    </footer>
  );
}
